export default __webpack_public_path__ + "static/media/ProposalInactiveLight.135a2e75.svg";